import binder from '../resources/mentors/binder.jpg'
import ana from '../resources/mentors/ana.jpg'
import mari from '../resources/mentors/mari.jpg'
import afonso from '../resources/mentors/afonso.jpg'
import flora from '../resources/mentors/flora.jpg'
import nath from '../resources/mentors/nath.jpg'
import maicris from '../resources/mentors/maicris.jpg'
import mark from '../resources/mentors/mark.jpg'
import veloso from '../resources/mentors/veloso.jpg'
import gabi from '../resources/mentors/gabi.jpg'
import munhoz from '../resources/mentors/munhoz.jpg'
import theo from '../resources/mentors/theo.jpg'
import gonzatto from '../resources/mentors/gonzatto.jpg'

const mentors = [
  {
    name: 'Fabio Binder',
    description: 'Coordenador ⭐️ do projeto, Mentor de Programação',
    image: binder,
  },
  {
    name: 'Maicris Fernandes',
    description: 'Mentor de Programação',
    image: maicris,
  },
  {
    name: 'Mark Joselli',
    description: 'Mentor de Programação, Responsável pelo Academy Masters',
    image: mark,
  },
  {
    name: 'Ana C Costa',
    description: 'Mentora de Design/UX',
    image: ana,
  },
  {
    name: 'Luiz Veloso',
    description: 'Mentor de Negócios e Programação',
    image: veloso,
  },
  {
    name: 'Rodrigo Gonzatto',
    description: 'Mentor de Design/UX',
    image: gonzatto,
  },
  {
    name: 'Afonso Rekbaim',
    description: 'Mentor Jr. de Programação',
    image: afonso,
  },
  {
    name: 'Flora Koti',
    description: 'Mentora Jr. de Design/UX',
    image: flora,
  },
  {
    name: 'Gabriela Nunes',
    description: 'Mentora Jr. de Design/UX',
    image: gabi,
  },
  {
    name: 'Gustavo Munhoz',
    description: 'Mentor Jr. de Programação',
    image: munhoz,
  },
  {
    name: 'Mariana Lukasinski',
    description: 'Mentora Jr. de Design/UX',
    image: mari,
  },
  {
    name: 'Natalia Schueda',
    description: 'Mentora Jr. de Produto',
    image: nath,
  },
  {
    name: 'Theo H Velasco',
    description: 'Mentor Jr. de Design/UX',
    image: theo,
  },
]

export default mentors
